import React from "react";
import { Link } from "react-router-dom";
import { recipes } from "../Datas/editorialData";
import siteConfig from "../config/siteConfig";
import "../css/editorial-pages.scss";
import useEditorialCollection from "../hooks/useEditorialCollection";
import EditorialCard from "./EditorialCard";
import EditorialFilters from "./EditorialFilters";
import PageMeta from "./PageMeta";

function Recipes() {
  const {
    categories,
    currentCategory,
    filteredEntries,
    query,
    setCategory,
    setQuery,
  } = useEditorialCollection(recipes);

  return (
    <main className="content-page editorial-page recipes-page">
      <PageMeta
        title="Italian pantry recipes"
        description={`Original, practical recipes from the ${siteConfig.brandName} pantry.`}
      />

      <header className="editorial-hero editorial-hero--recipes">
        <div className="page-shell editorial-hero__grid">
          <div className="editorial-hero__copy">
            <p className="eyebrow">Recipes from our table</p>
            <h1>Cook simply. Season generously.</h1>
            <p>
              Flexible recipes built around good pantry ingredients, useful
              technique, and the pleasure of making dinner without a performance.
            </p>
          </div>
          <div className="editorial-hero__aside" aria-label="Recipe collection summary">
            <strong>{recipes.length}</strong>
            <span>Original kitchen notes</span>
            <p>Weeknight bowls, slow suppers, aperitivo, and something sweet.</p>
          </div>
        </div>
      </header>

      <section className="page-section page-shell editorial-listing" aria-labelledby="recipe-list-title">
        <div className="section-heading editorial-listing__heading">
          <p className="eyebrow">Choose a starting point</p>
          <h2 id="recipe-list-title">Recipes for a working pantry</h2>
        </div>

        <EditorialFilters
          categories={categories}
          currentCategory={currentCategory}
          query={query}
          resultCount={filteredEntries.length}
          onCategoryChange={setCategory}
          onSearch={setQuery}
        />

        {filteredEntries.length > 0 ? (
          <div className="editorial-card-grid">
            {filteredEntries.map((recipe) => (
              <EditorialCard key={recipe.id} entry={recipe} type="recipe" />
            ))}
          </div>
        ) : (
          <div className="editorial-empty" role="status">
            <p className="eyebrow">Nothing simmering here yet</p>
            <h2>No recipes match those filters.</h2>
            <p>Try a broader search, clear the category, or explore the pantry.</p>
            <Link className="button button--primary" to="/shop">
              Shop all ingredients
            </Link>
          </div>
        )}
      </section>

      <section className="editorial-crosslink">
        <div className="page-shell editorial-crosslink__inner">
          <div>
            <p className="eyebrow">Keep reading</p>
            <h2>The ingredient story matters, too.</h2>
          </div>
          <Link className="button button--secondary" to="/journal">
            Visit the journal
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Recipes;
